import React from 'react';
import { Heading, HeadingHierarchy } from '../../../_lib/components/Heading/Heading';
import { PostsEditor } from '../../../_lib/components/Posts';
import { useAppContext } from '../../../contexts/AppContext/AppContext';
import { SonForm } from '../../../_lib/Form2';
import { useBlockContext } from '../../../_lib/BlockFetcher';

type ThreadBlockMainEditor = {
  hierarchy: HeadingHierarchy;
  headline: string;
  createForm?: SonForm<any>;
};

/**
 * Main Editor for Threads which creates new Posts.
 * Located at the bottom of a thread and will not be shown when page is in editmode.
 */
export function ThreadBlockMainEditor({ createForm, hierarchy, headline }: ThreadBlockMainEditor) {
  const { editModeInfo } = useAppContext();
  const { uuid } = useBlockContext();

  if (!createForm || editModeInfo.active) {
    return null;
  }

  return (
    <div className="thread__main-editor" id="threads-main-editor">
      <Heading hierarchy={hierarchy} className="posts__heading font-bold-15-19">
        {headline}
      </Heading>
      <div id="thread-main-editor">
        <PostsEditor form={createForm} type="thread" uuid={uuid} />
      </div>
    </div>
  );
}
